import { JarticardsClient } from '@/components/jarticards/JarticardsClient';

export default function JarticardsPage() {
  return <JarticardsClient />;
}
